export default __webpack_public_path__ + "static/media/hydrant.e8950244.png";